import * as React from 'react';
import { Toggle } from '@payscale/design';
import './settingToggle.scss';

export interface ISettingToggleProps {
    className?: string;
    body: React.ReactNode;
    initialValue: boolean;
    settingName: React.ReactNode;
    settingId: string;
    onChange: (id: string, value: boolean) => void;
}

export interface ISettingToggleState {
    isSettingOn: boolean;
}

export default class SettingToggle extends React.Component<ISettingToggleProps, ISettingToggleState> {
    constructor(props: ISettingToggleProps) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
        this.state = {
            isSettingOn: this.props.initialValue
        };
    }

    render(): React.ReactNode {
        const { body, settingId, settingName } = this.props;
        const className = this.props.className || '';
        return (
            <div className={`setting-toggle ${this.state.isSettingOn ? 'setting-toggle--on' : ''} ${className}`}>
                <div className="setting-toggle__header">
                    <h4 className="setting-toggle__name">{settingName}</h4>
                    <Toggle
                        id={settingId}
                        value={this.state.isSettingOn}
                        onChange={this.handleToggle}
                    />
                </div>
                <div className="setting-toggle__body">
                    <div className="setting-toggle__body-inner">
                        {body}
                    </div>
                </div>
            </div>
        );
    }

    private handleToggle(id: string, value: boolean): void {
        this.setState({
            isSettingOn: value
        });
        this.props.onChange(id, value);
    }
}